import React, {useRef} from 'react';
import Status from "../../../../model2/status/status";
import PopoverMenuOptionStatus from "../../../../gd-components/popover-menu/popover-menu/menu-option-status";
import PopoverMenuSeparator from "../../../../gd-components/popover-menu/popover-menu/popover-menu-separator";
import PopoverHelpHint from "../../../../gd-components/popover-menu/popover-help-hint/popover-help-hint";
import Classes from "classnames";

type Props = {
    statusesGrouped     :   any[]
    onStatusClick       :   callback
    handleHoverOn?      :   callback
    handleHoverOff?     :   callback
    hint?               :   boolean
    onEditStatusesClick :   callback
    classes?            :   string
}

export default function TaskStatusMenu(props: Props) {

    const refHintMessage = useRef<any>(null)

    const classes = Classes("ui5-popover-menu", "with-help", props.classes)

    return (
        <div className={classes}>

            {props.statusesGrouped.map((group, key) => {

                const isLast = key === _.size(props.statusesGrouped) - 1

                return (
                    <div key={key} className="">
                        {group[1].map((status: Status, key: number) => {
                            return <PopoverMenuOptionStatus key             =   {key}
                                                            status          =   {status}
                                                            onClick         =   {props.onStatusClick}
                                                            onMouseEnter    =   {props.handleHoverOn}
                                                            onMouseLeave    =   {props.handleHoverOff}
                            />
                        })}

                        {!isLast && <PopoverMenuSeparator/>}

                    </div>
                )
            })}

            {props.hint &&
                <PopoverHelpHint ref={refHintMessage} defaultMessage={"Select task status"} className=""/>}

            {props.hint && gd.ac.check.company.isManager() && (
                <div className="customize">
                    <div className="ui5-ico-15 i5-wrench m-r-8"/>
                    <div className="ui5-txt-link-small-no-accent lh-13em" onClick={props.onEditStatusesClick}>
                        Edit workflow
                    </div>
                </div>
            )}

        </div>
    );
}
